import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-24/task-01";

const task: Slide = {
  titleHtml:
    "Which of the following figures represent the apparent resistance of a blocked<br>voice-coil (cannot move) inside a motor of a traditional electrodynamic loudspeaker?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
